import { useTranslation } from 'react-i18next';
import ProductCarousel from './ProductCarousel';
import { productCategories } from '@/mocks/products';

export default function ProductsSection() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50">
      <div className="py-4 md:py-6">
        <div className="px-4 md:px-6 lg:px-8 xl:px-12">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 tracking-tight">
              {t('products.title')}
            </h2>
            <a
              href="https://kaspreadsheet.com/index.html"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap"
            >
              {t('products.viewFull')}
              <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
          <p className="text-sm text-foreground-600 mb-4 md:mb-6 max-w-2xl">
            {t('products.subtitle')}
          </p>
        </div>
      </div>

      {productCategories.map((cat, idx) => (
        cat.products.length > 0 && (
          <div
            key={cat.slug}
            className={idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/60'}
          >
            <ProductCarousel categoryIndex={idx} />
          </div>
        )
      ))}

      <div className="py-10 md:py-14 px-4 md:px-6 lg:px-8 xl:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <h3 className="text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
            {t('products.wantMore')}
          </h3>
          <p className="text-sm md:text-base text-foreground-600 mb-6">
            {t('products.moreDesc')}
          </p>
          <a
            href="https://kaspreadsheet.com/index.html"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 font-semibold px-6 py-3 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-external-link-line w-4 h-4 flex items-center justify-center" />
            {t('products.visitFull')}
          </a>
        </div>
      </div>
    </div>
  );
}